module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2m7GO"))).then(() => parcelRequire('5RvcM'));